import BasicApiFormatter from '@modules/basic-api-formatter';

/**
 *
 *
 */
class FileUploadApiFormatter {
  /**
   *
   * @param {*} payload
   * @return {Object}
   */
  static pack(payload) {
    const headers = new Headers();
    const body = new FormData();

    headers.append('Accept', '*/*');
    headers.append('X-Requested-By', 'Enterprise');

    body.append('arguments', JSON.stringify(payload.arguments));
    body.append('file', payload.file);

    return BasicApiFormatter.getRequestConfig(headers, body);
  }

  /**
   *
   * @param {*} response
   * @return {Promise}
   */
  static unpack(response) {
    return response.json()
      .then((data) => {
        if (data.success !== 'TRUE') {
          return Promise.reject(data.payload);
        }
        return data.payload;
      });
  }
}

export default FileUploadApiFormatter;
